unit Client.Constants.Geo;

interface

uses JS, Web, Classes;

type
  TCoord = record
    Lat: double;
    Lon: double;
  end;

var
  geoSJS: TCoord;
  geoZC: TCoord;

implementation

initialization
  // SJS Dragonja
  geoSJS.Lon := 13.658973;
  geoSJS.Lat := 45.463731;

  // ZC Dragonja
  geoZC.Lon := 13.668753;
  geoZC.Lat := 45.453947;

end.
